import { RefCallback, RefObject } from 'react';

export function mergeRefs<T>(
  ...refs: Nullable<RefCallback<T> | RefObject<T>>[]
) {
  return (instance: T | null) => {
    refs.forEach(ref => {
      if (typeof ref === 'function') {
        ref(instance as T);
      } else if (ref != null) {
        ref.current = instance as T;
      }
    });
  };
}
